import { devTypes, ProjectType } from "src/constants/common";
import { CreatePorjectForm } from "src/types/form";

import { saveAs } from "file-saver";
import { adminInstance } from "src/dataProvider/axios";

import * as XLSX from "xlsx";
import * as XLSXS from "xlsx-style";
import ExcelJS from "exceljs";

export const capitalize = (label: string) =>
  label?.charAt(0).toUpperCase() + label.slice(1);

export const dateAndTimeStamp = (dateStr: string, timeZone = "UTC") => {
  const date = new Date(dateStr);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: timeZone,
  };

  const formattedDate = date.toLocaleString("en-US", options);

  const [newDate, time] = formattedDate.split(",");

  const [month, day, year] = newDate.split("/");

  return `${day}/${month}/${year}, ${time}`;
};

/**
 * Indian financial year label for a date: 1 April YYYY – 31 March YYYY+1.
 *   2024-04-01 … 2025-03-31 -> "2024-2025"
 *   2025-04-01 … 2026-03-31 -> "2025-2026"
 *   2026-04-01 … 2027-03-31 -> "2026-2027"  (and so on)
 *
 * Read in IST, not the browser's zone: the 1 April cut-off is an Indian
 * calendar rule, and a timestamp just either side of midnight would otherwise
 * fall in the wrong year for a viewer in another timezone. Returns "-" when
 * there is no usable date (e.g. an application whose payment is not released).
 */
export const getFinancialYear = (date?: string | Date | null) => {
  if (!date) return "-";

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "-";

  const [month, , year] = parsed
    .toLocaleDateString("en-US", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .map(Number);

  // Jan–Mar still belong to the financial year that opened the previous April.
  const startYear = month >= 4 ? year : year - 1;

  return `${startYear}-${startYear + 1}`;
};

export const getFormattedDate = (date: string) => {
  if (date) {
    const newDate = new Date(date);
    const month =
      newDate.getMonth() + 1 < 10
        ? `0${newDate.getMonth() + 1}`
        : `${newDate.getMonth() + 1}`;

    const day =
      newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate();

    const year = newDate.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return "-";
};

export const getSignUpData = (data: any, addressDetails: any) => {
  const type = data.userType.formData.devType;
  const {
    userType,
    personalDetails,
    aadhaarVerification,
    documentUpload,
    organisationDetails,
  } = data;
  if (type === "ORGANIZATION") {
    return {
      userType: userType.formData.devType,
      role: userType.formData.userType,
      firstName: organisationDetails.formData.AuthorisedRepresentativeName, //  representativeName
      email: organisationDetails.formData.email,
      countryCode: organisationDetails.formData.phone.countryCode,
      phoneNumber: organisationDetails.formData.phone.number,
      password: organisationDetails.formData.password,
      isAddressSame: !!addressDetails.isAddressSame,
      // notificationPreference: 1,
      ...(!addressDetails.isAddressSame && {
        currentAddress: {
          //in cse of false
          addressLine1: addressDetails?.currentAddress.address,
          // addressLine2: "",
          // village: "Village_name",
          city: addressDetails?.currentAddress.city,
          district: addressDetails?.currentAddress.district,
          state: addressDetails?.currentAddress.state,
          country: "india",
          isoCode: "INR",
          zipCode: "90210",
          // latitude: "0.3",
          // longitude: "0.7",
        },
      }),

      organizationDetail: {
        organizationName: organisationDetails.formData.organisationName,
        organizationType: organisationDetails.formData.organisationType,
        representativeDesignation: "Manage",

        documentDetail: {
          type: documentUpload.formData.documentType,
          serialNo: documentUpload.formData.documentImage[0]?.key, // `${generateRandomString(10)}`,
          frontUrl: documentUpload.formData.documentImage[0]?.file,
          backUrl: documentUpload.formData.documentImage[0]?.file,
          isVerified: false,
          // validFrom: documentUpload.formData.registration || undefined,
        }, //  same as aadhar structure, add one more key "validFrom" for date of registration
        // notificationPreference: 1,
      },
      permanentAddress: {
        //permanent
        addressLine1: addressDetails?.permanentAddress.address,
        // addressLine2: "ddsadas",
        village: "dsada",
        city: addressDetails?.permanentAddress.city,
        district: addressDetails?.permanentAddress.district,
        state: addressDetails?.permanentAddress.state,
        country: "india",
        isoCode: "INR",
        zipCode: "90210",
        // latitude: "0.3",
        // longitude: "0.7",
      },
    };
  }

  return {
    userType: userType.formData.devType,
    role: userType.formData.userType,
    firstName: personalDetails.formData.fullName,
    email: personalDetails.formData.email,
    countryCode: personalDetails.formData.phone.countryCode,
    phoneNumber: personalDetails.formData.phone.number,
    password: personalDetails.formData.password,
    isAddressSame: !!addressDetails.isAddressSame, // in case true then permananent otherwise both
    // notificationPreference: 1, // to be remove
    permanentAddress: {
      addressLine1: addressDetails?.permanentAddress.address,
      // addressLine2: "ddsadas",
      // village: "dsada",
      city: addressDetails?.permanentAddress.city,
      district: addressDetails?.permanentAddress.district,
      state: addressDetails?.permanentAddress.state,
      country: "india",
      isoCode: "INR",
      zipCode: addressDetails.permanentAddress.pinCode, // pin code
      // latitude: "0.3",
      // longitude: "0.7",
    },
    ...(!addressDetails.isAddressSame && {
      currentAddress: {
        addressLine1: addressDetails?.currentAddress.address,
        // addressLine2: "ddsadas",
        // village: "dsada",
        city: addressDetails?.currentAddress.city,
        district: addressDetails?.currentAddress.district,
        state: addressDetails?.currentAddress.state,
        country: "india",
        isoCode: "INR",
        zipCode: addressDetails.permanentAddress.pinCode,
      },
    }),
    aadhaarDetails: {
      type: "AADHAAR",
      serialNo: aadhaarVerification.formData.aadhaarCard[0]?.key,
      frontUrl: aadhaarVerification.formData.aadhaarCard[0]?.file,
      backUrl: aadhaarVerification.formData.aadhaarCardBack[0]?.file,
      isVerified: false,
    },
  };
};

export const optionTypeFomatter = (arr, key = false) => {
  if (!arr?.length) return [];
  return arr?.map(({ name, id, isActive }) => {
    return {
      label: name,
      value: key ? name : id,
      isActive: isActive,
      id: id,
    };
  });
};
export const optionTypeFomatterByType = (arr, key = false) => {
  if (!arr?.length) return [];
  return arr?.map(({ type, id, isActive }) => {
    return {
      label: type,
      value: key ? type : id,
      isActive: isActive,
      id: id,
    };
  });
};

export const createProjectData = (key: string, data: CreatePorjectForm) => {
  const {
    orgDetails,
    bankDetails,
    gcBankDetails,
    plotSiteAreaDetails,
    projectAreaDetails,
    // projectDetails,
  } = data;

  const { organizationAffiliationDetail } = orgDetails;

  if (key === devTypes.ORGANIZATION) {
    return {
      name: orgDetails.organizationAffiliationDetail.projectName,
      projectType: "TREE_PLANTATION",
      landArea: Number(plotSiteAreaDetails.landArea),
      areaUnit: plotSiteAreaDetails.areaUnit,
      landOwnershipTypeId: "e8b45136-850e-49d5-a601-8308736f3474",
      landCategoryId: plotSiteAreaDetails.landCategory,
      projectStartDate: plotSiteAreaDetails.startDate,
      projectDuration: Number(plotSiteAreaDetails.projectDuration),
      organizationAffiliationDetail: {
        noOfEmployee: Number(organizationAffiliationDetail.noOfEmployee),
        incomeBracketRangeId: "3bf75f28-88ef-4250-810a-19ad41ba54c2",
        annualTurnover: Number(organizationAffiliationDetail.annualTurnover),
        industryTypeId: organizationAffiliationDetail.industryTypeId,
      },
      treeSpecificationDetail: [
        {
          treeType: 0,
          treeCount: Number(plotSiteAreaDetails.existingTreeCount),
          speciesName: plotSiteAreaDetails.existingTree,
        },
        {
          treeSpeciesId: plotSiteAreaDetails.treeSpicies,
          treeType: 1,
          treeCount: Number(plotSiteAreaDetails.treeCount),
          ageOfSaplings: Number(plotSiteAreaDetails.ageOfSaplings),
          sourceOfSaplings: plotSiteAreaDetails.sourceOfSaplings,
        },
      ],

      bankAccountDetail: {
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
        accountNumber: bankDetails.accountNumber,
        branchState: bankDetails.branchState,
        branchDistrict:
          bankDetails.branchDistrict && bankDetails.branchDistrict.id,
        branchLocation: bankDetails.branch,
      },
      address: {
        addressLine1: "string",
        city: projectAreaDetails.city,
        district: projectAreaDetails.district && projectAreaDetails.district.id,
        state: projectAreaDetails.state,
        country: "india",
        isoCode: "string",
        zipCode: "string",
        latitude: 40.7128,
        longitude: 40.7128,
      },
      documentDetail: [
        ...organizationAffiliationDetail.projectProfileUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...projectAreaDetails.documentUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.sourceSaplingImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.ownershipImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.plantationImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...bankDetails.documentDetailUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...gcBankDetails.documentDetailUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
      ],
    };
  } else if (key === devTypes.INDIVIDUAL) {
    return {
      name: orgDetails.individualDetails.projectName,
      projectType: ProjectType.TREE_PLANTATION,
      landArea: Number(plotSiteAreaDetails.landArea),
      areaUnit: plotSiteAreaDetails.areaUnit,
      landOwnershipTypeId: plotSiteAreaDetails.ownerShip,
      landCategoryId: plotSiteAreaDetails.landCategory,
      projectStartDate: plotSiteAreaDetails.startDate,
      projectDuration: Number(plotSiteAreaDetails.projectDuration),
      organizationAffiliationDetail: {
        incomeBracketRangeId: orgDetails.individualDetails.annualIncome,
        // annualTurnover: Number(orgDetails.individualDetails.annualIncome),
      },

      treeSpecificationDetail: [
        {
          treeType: 0,
          treeCount: Number(plotSiteAreaDetails.existingTreeCount),
          speciesName: plotSiteAreaDetails.existingTree,
        },
        {
          treeSpeciesId: plotSiteAreaDetails.treeSpicies,
          treeType: 1,
          treeCount: Number(plotSiteAreaDetails.treeCount),
          ageOfSaplings: Number(plotSiteAreaDetails.ageOfSaplings),
          sourceOfSaplings: plotSiteAreaDetails.sourceOfSaplings,
        },
      ],

      bankAccountDetail: {
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
        accountNumber: bankDetails.accountNumber,
        branchState: bankDetails.branchState,
        branchDistrict:
          bankDetails.branchDistrict && bankDetails.branchDistrict?.id,
        branchLocation: bankDetails.branch,
        documentDetailUrl: bankDetails.documentDetailUrl,
      },
      address: {
        addressLine1: "string",
        city: projectAreaDetails.city,
        district:
          projectAreaDetails.district && projectAreaDetails.district?.id,
        state: projectAreaDetails.state,
        country: "india",
        isoCode: "string",
        zipCode: "string",
        latitude: 40.7128,
        longitude: 40.7128,
      },
      documentDetail: [
        ...orgDetails.individualDetails.projectProfileUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...projectAreaDetails.documentUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.sourceSaplingImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.ownershipImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...plotSiteAreaDetails.plantationImg.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...bankDetails.documentDetailUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
        ...gcBankDetails.documentDetailUrl.map((item: any) => {
          return { documentUrl: item.key, type: item.type };
        }),
      ],
    };
  }
  return {};
};

export const createProjectDataForWater = (
  key: string,
  data: CreatePorjectForm
) => {
  const {
    waterPlotArea,
    waterProjectArea,
    waterStructureDetails,
    waterEntityDetails,
    bankDetails,
  } = data;
  if (key === devTypes.ORGANIZATION) {
    return {
      name: waterEntityDetails.projectName,
      // "projectTypeId": "b96b19de-ff65-4727-86c5-6880dd550f9f", // Water
      projectType: ProjectType.WATER_CONSERVATION,
      landArea: Number(waterPlotArea.area),
      areaUnit: "ha",
      landOwnershipTypeId: waterPlotArea.ownership,
      landCategoryId: waterPlotArea.landUse,
      // projectStartDate: localDataConverter(waterStructureDetails.startDate),
      projectStartDate: "2014-04-17T13:11:30.000+01:00",
      projectDuration: Number(waterStructureDetails.projectDuration),
      organizationAffiliationDetail: {
        noOfEmployee: Number(waterEntityDetails.noOfEmployee),
        incomeBracketRangeId: "3bf75f28-88ef-4250-810a-19ad41ba54c2",
        annualTurnover: Number(waterEntityDetails.annualTurnover),
        industryTypeId: waterEntityDetails.industryTypeId,
        projectProfileUrl: "organizationAffiliationDetail.projectProfileUrl",
      },
      waterConservationDetail: {
        // water type details
        structureTypeId: waterStructureDetails.type,
        materialDetailId: waterStructureDetails.material,
        potentialCapacity: Number(waterStructureDetails.capacity),
        cost: Number(waterStructureDetails.cost),
      },
      treeSpecificationDetail: [],
      bankAccountDetail: {
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
        accountNumber: bankDetails.accountNumber,
        branchState: bankDetails.branchState,
        branchDistrict: bankDetails.branch,
        // bankDetails.branchDistrict && bankDetails.branchDistrict.id,
        branchLocation: bankDetails.branch,
        documentDetailUrl: bankDetails.documentDetailUrl,
      },
      address: {
        addressLine1: "string",
        city: waterProjectArea.city,
        district: waterProjectArea.district && waterProjectArea.district.id,
        state: waterProjectArea.state,
        country: "india",
        isoCode: "string",
        zipCode: "string",
        latitude: 40.7128,
        longitude: 40.7128,
      },
      documentDetail: [
        {
          documentUrl: "url id",
          type: "LAND_OWNERSHIP",
        },
      ],
    };
  } else {
    return {
      name: waterEntityDetails.projectName,
      projectType: ProjectType.WATER_CONSERVATION,
      landArea: Number(waterPlotArea.area),
      areaUnit: "ha",
      landOwnershipTypeId: waterPlotArea.ownership,
      landCategoryId: waterPlotArea.landUse,
      projectStartDate: "2014-04-17T13:11:30.000+01:00",
      projectDuration: Number(waterStructureDetails.projectDuration),
      organizationAffiliationDetail: {
        incomeBracketRangeId: "3bf75f28-88ef-4250-810a-19ad41ba54c2",
      },
      waterConservationDetail: {
        // water type details
        structureTypeId: waterStructureDetails.type,
        materialDetailId: waterStructureDetails.material,
        potentialCapacity: Number(waterStructureDetails.capacity),
        cost: Number(waterStructureDetails.cost),
      },
      treeSpecificationDetail: [],
      bankAccountDetail: {
        bankName: bankDetails.bankName,
        ifscCode: bankDetails.ifscCode,
        accountHolderName: bankDetails.accountHolderName,
        accountNumber: bankDetails.accountNumber,
        branchState: bankDetails.branchState,
        branchDistrict: bankDetails.branch,
        // bankDetails.branchDistrict && bankDetails.branchDistrict.id,
        branchLocation: bankDetails.branch,
        documentDetailUrl: bankDetails.documentDetailUrl,
      },
      address: {
        addressLine1: "string",
        city: waterProjectArea.city,
        district: waterProjectArea.district && waterProjectArea.district.id,
        state: waterProjectArea.state,
        country: "india",
        isoCode: "string",
        zipCode: "string",
        latitude: 40.7128,
        longitude: 40.7128,
      },
      documentDetail: [
        {
          documentUrl: "url id",
          type: "LAND_OWNERSHIP",
        },
      ],
    };
  }
};

export const manipulatePlantationFormData = (data: any) => {
  return {
    project: data.projectType,
    orgDetails: {
      organizationAffiliationDetail: {
        name: data.organizationAffiliationDetail.name,
        organisationType: data.organizationAffiliationDetail.id,
        noOfEmployee: data.organizationAffiliationDetail.noOfEmployee,
        annualTurnover: data.organizationAffiliationDetail.annualTurnover,
        industryTypeId: data.organizationAffiliationDetail.industryTypeId,
        incomeBracketRangeId:
          data.organizationAffiliationDetail.incomeBracketRangeId,
        projectProfileUrl: [],
        projectName: data.name,
      },
    },

    plotSiteAreaDetails: {
      img: [],
      landArea: data.landArea,
      areaUnit: data.areaUnit,
      landCategory: data.landCategoryId,
      ownerShip: data.landOwnershipTypeId,
      spiciesType: data.treeSpecificationDetail.length
        ? data.treeSpecificationDetail[0]?.speciesName
        : "",
      treeSpicies: data.treeSpecificationDetail.length
        ? data.treeSpecificationDetail[0]?.treeSpeciesId
        : "",
      treeCount: data.treeSpecificationDetail.length
        ? data.treeSpecificationDetail[0]?.treeCount
        : "",
      layoutPlantation: "",
      ageOfSaplings: data.treeSpecificationDetail.length
        ? data.treeSpecificationDetail[0]?.ageOfSaplings
        : "",
      sourceOfSaplings: data.treeSpecificationDetail.length
        ? data.treeSpecificationDetail[0]?.sourceOfSaplings
        : "",
      startDate: data.projectStartDate,
      projectDuration: data.projectDuration,
    },

    bankDetails: {
      bankName: data.bankAccountDetail.bankName,
      ifscCode: data.bankAccountDetail.ifscCode,
      accountHolderName: data.bankAccountDetail.accountHolderName,
      accountNumber: data.bankAccountDetail.accountNumber,
      branchState: data.bankAccountDetail.branchState,
      branchDistrict: data.bankAccountDetail.branchDistrict,
      branch: data.bankAccountDetail.branchLocation,
      documentDetailUrl: [],
    },
    treeSpecificationDetail: [
      {
        id: "9a4e8e2b-bb38-4ed9-8179-1e73a0561f16",
        treeSpeciesId: "e233c9ea-1693-49d1-b9c0-9c3571c7150c",
        // "speciesName": "asd",
        treeType: 0,
        treeCount: 3,
        ageOfSaplings: 333,
        sourceOfSaplings: "Nursery A4",
      },
      {
        id: "82eb4f79-0763-4c48-9b43-6421c7e2f8f7",
        treeSpeciesId: "e233c9ea-1693-49d1-b9c0-9c3571c7150c",
        // "speciesName": "asd",
        treeType: 1,
        treeCount: 5,
        ageOfSaplings: 555,
        sourceOfSaplings: "Nursery B4",
      },
    ],
    projectAreaDetails: {
      img: [],
      addressLine1: data.address.addressLine1,
      addressLine2: null,
      village: data.address.village,
      city: data.address.city,
      district: data.address.district,
      state: data.address.state,
      country: data.address.country,
      isoCode: data.address.isoCode,
      zipCode: data.address.zipCode,
      latitude: data.address.latitude,
      longitude: data.address.longitude,
    },

    gcBankDetails: {
      documentDetailUrl: [],
      bankName: "",
      ifscCode: "",
      accountHolderName: "",
      accountNumber: null,
      branch: "",
      state: "",
    },

    documentDetail: [
      {
        id: "72080c39-273f-40f3-8608-da6094411e43",
        serialNo: null,
        documentUrl:
          "https://greencreditbucket.s3.ap-south-1.amazonaws.com/greenCreditKeyPrefix1699266154133?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVCOYGCWF3XK2CG6I%2F20231106%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20231106T111314Z&X-Amz-Expires=120&X-Amz-Signature=41ac92a6e049ad59a40437098c98ccfe758fa2e6c6dda633b21a927d34320104&X-Amz-SignedHeaders=host",
        isVerified: false,
        type: "LAND_OWNERSHIP",
        validFrom: null,
        validTill: null,
      },
    ],
    images: [],

    provisionalDetails: [
      {
        year: 2.5,
        percentage: 25,
      },
      {
        year: 5,
        percentage: 25,
      },
      {
        year: 7.5,
        percentage: 25,
      },
      {
        year: 10,
        percentage: 25,
      },
    ],
  };
};

export const localDateConverter = (dateString: string) => {
  const date = new Date(dateString);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
};

// export function downloadSheet(data: any) {
//   const worksheet = XLSX.utils.json_to_sheet(data);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });
//   const blob = new Blob([excelBuffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
//   });

//   saveAs(blob, "data.xlsx");
// }

/**
 * Generates a standardised export filename.
 * Pattern: <slug>_YYYY-MM-DD_HH-mm  (24-hr, no colons — safe on all OS/filesystems)
 * Example: progress-details_2026-05-12_15-54.xlsx
 */
export function generateExportFilename(
  slug: string,
  timeZone = "Asia/Kolkata"
): string {
  const now = new Date();
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = fmt.formatToParts(now);
  const get = (type: string) =>
    parts.find((p) => p.type === type)?.value ?? "00";
  const date = `${get("year")}-${get("month")}-${get("day")}`;
  const time = `${get("hour")}-${get("minute")}`;
  return `${slug}_${date}_${time}.xlsx`;
}

export function downloadSheet(data: any, filename?: string) {
  // Create a worksheet from the data
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Adjust column width
  const columnWidths = data.length
    ? Object.keys(data[0]).map((key) => ({
        wch: Math.max(
          key.length, // header width
          ...data.map((row: any) => (row[key] ? row[key].toString().length : 0)) // cell width
        ),
      }))
    : [];

  worksheet["!cols"] = columnWidths;

  // Optional: Adjust row height for the header (popular height)
  const popularHeaderHeight = 30; // Example height in points
  worksheet["!rows"] = [{ hpt: popularHeaderHeight }]; // Header height

  // Create a workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Generate an Excel file in buffer format
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Create a Blob from the buffer and trigger download
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, filename ?? "data.xlsx");
}

interface Entry {
  numberOfEntries: number;
  totalArea: number;
}

interface StateData {
  [stateName: string | number]: {
    [status: string | number]: Entry;
  }[];
}

export function formatData(stats: StateData[]) {
  const formattedData: string[][] = [];

  stats.forEach((stateStats, index) => {
    const stateName = Object.keys(stateStats)[0]; // Extract state name
    const entries = stateStats[stateName]; // Extract entries for the state
    let stateEntries: string[] = [];
    stateEntries.push((index + 1).toString(), stateName);
    entries.forEach((entry) => {
      if (entry) {
        const statusName = Object.keys(entry)[0]; // Extract status name
        // const { numberOfEntries, totalArea } = entry[statusName]; // Extract number of entries and total area
        stateEntries.push(
          entry[statusName][Object.keys(entry[statusName])[0]],
          entry[statusName][Object.keys(entry[statusName])[1]]
        );
      } else {
        stateEntries.push("0", "0");
      }
    });
    formattedData.push(stateEntries);
  });

  console.log(formattedData);
  return formattedData;
}

export function extractStates(data) {
  const firstEntity = data?.stats[0];
  const entityName = Object.keys(firstEntity)[0]; // Get the name of the first entity
  const statesArray = firstEntity[entityName].map(
    (stateObj) => Object.keys(stateObj)[0]
  ); // Extract states

  return statesArray;
}

export const formatDataForBarChart = (stats) => {
  return stats?.map((stat) => ({
    name: stat.description,
    uv: stat.number,
    pv: Number(stat.totalArea),
    amt: stat.totalArea,
  }));
};

export const formatToIndianCurrency = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace("₹", "₹ ");
};

export const formatINR = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace("₹", "");
};

export const TableformatToIndianCurrency = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    currencyDisplay: "code",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace("INR", "").trim();
};

export async function exportProgressReportTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("ProgressReport");
  const border = {
    top: { style: "thin" as const },
    left: { style: "thin" as const },
    bottom: { style: "thin" as const },
    right: { style: "thin" as const },
  };
  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border,
  };
  const headerStyle = {
    ...centerStyle,
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" },
    },
    font: { bold: true },
  };

  const topHeaderSpans = [3, 2, 2];
  let column = 1;
  topHeader.forEach((title, index) => {
    const span = topHeaderSpans[index] ?? 1;
    worksheet.getCell(1, column).value = title;
    worksheet.mergeCells(1, column, 1, column + span - 1);
    for (let current = column; current < column + span; current++) {
      worksheet.getCell(1, current).style = headerStyle;
    }
    column += span;
  });

  const headerRow = worksheet.addRow(header);
  headerRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.style = headerStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.indicatorName,
        row.targetInUnits,
        row.costTarget,
        row.progressInUnits,
        row.costProgress,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  worksheet.columns.forEach((worksheetColumn) => {
    worksheetColumn.width = 20;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "ProgressReport.xlsx"
  );
}

export async function exportTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  // Define styles
  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  // Add top header row and apply styles and merges
  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle, index) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1); // Merging cells for the top header
    topHeaderColStart += 2; // Move to the next pair of columns
  });

  // Add and style header row
  const headerRowIndex = 2; // The header row will be the second row
  worksheet.addRow(header); // Add header values
  header.forEach((item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberRegistered,
        row.totalAreaRegistered,
        row.totalNumberGenerateDemandNote,
        row.totalAreaGenerateDemandNote,
        row.totalNumberNodalUnderQuery,
        row.totalAreaNodalUnderQuery,
        row.totalNumberVerifyDemandNote,
        row.totalAreaVerifyDemandNote,
        row.totalNumberUnderQuery,
        row.totalAreaUnderQuery,
        row.totalNumberPaymentPending,
        row.totalAreaPaymentPending,
        row.totalNumberPaymentDone,
        row.totalAreaPaymentDone,
        row.totalNumberDemandNoteGenerated,
        row.totalAreaDemandNoteGenerated,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  // Generate the file and save it
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DashboardTable.xlsx"
  );
}

export async function exportEcoRestorationTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  // Define styles
  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  // Add top header row and apply styles and merges
  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle, index) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1); // Merging cells for the top header
    topHeaderColStart += 2; // Move to the next pair of columns
  });

  // Add and style header row
  const headerRowIndex = 2; // The header row will be the second row
  worksheet.addRow(header); // Add header values
  header.forEach((item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  // Add data rows with center alignment
  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberRegistered,
        row.totalAreaRegistered,
        row.totalNumberNodalVerificationPending,
        row.totalAreaNodalVerificationPending,
        row.totalNumberVerificationPending,
        row.totalAreaVerificationPending,
        row.totalNumberNodalUnderQuery,
        row.totalAreaNodalUnderQuery,
        row.totalNumberUnderQuery,
        row.totalAreaUnderQuery,
        row.totalNumberApproved,
        row.totalAreaApproved,
        row.totalNumberOldApproved,
        row.totalAreaOldApproved,
        row.totalNumberRejected,
        row.totalAreaRejected,
        row.totalNumberWithdrawn,
        row.totalAreaWithdrawn,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  // Generate the file and save it
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DashboardTable.xlsx"
  );
}

export async function exportEntityTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  let topHeaderColStart = 4;
  topHeader.forEach((headerTitle, index) => {
    if (headerTitle == "") return;
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    console.log(headerTitle, 1, topHeaderColStart, 1, topHeaderColStart + 1);
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1); // Merging cells for the top header
    topHeaderColStart += 2; // Move to the next pair of columns
  });

  // Merge the first three columns in the top header row
  worksheet.mergeCells(1, 1, 1, 3);
  worksheet.getCell(1, 1).value = ""; // You can set this value if needed
  worksheet.getCell(1, 1).style = greyHeaderStyle;

  // Add and style header row
  const headerRowIndex = 2; // The header row will be the second row
  worksheet.addRow(header); // Add header values
  header.forEach((item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  // Add data rows with center alignment
  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.entityName,
        row.state,
        row.totalBlocks,
        row.totalBlocksArea,
        row.totalNumberOfGenerateDemandNote,
        row.totalAreaOfGenerateDemandNote,
        row.totalNumberOfVerificationPending,
        row.totalAreaOfVerificationPending,
        row.totalNumberOfDemandNotePending,
        row.totalAreaOfDemandNotePending,
        row.totalNumberOfDemandNoteReleased,
        row.totalAreaOfDemandNoteReleased,
        row.numberPaymentPending,
        row.areaPaymentPending,
        row.numberPaymentDone,
        row.areaPaymentDone,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  // Generate the file and save it
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DashboardTable.xlsx"
  );
}

export async function exportSelectedLandTable(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  // Define styles
  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  // Add top header row and apply styles and merges
  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle, index) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1); // Merging cells for the top header
    topHeaderColStart += 2; // Move to the next pair of columns
  });

  // Add and style header row
  const headerRowIndex = 2; // The header row will be the second row
  worksheet.addRow(header); // Add header values
  header.forEach((item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberRegistered,
        row.totalAreaRegistered,
        row.totalNumberApproved,
        row.totalAreaApproved,
        row.totalNumberSelected,
        row.totalAreaSelected,
        row.totalNumberAvailable,
        row.totalAreaAvailable,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  // Generate the file and save it
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DashboardTable.xlsx"
  );
}

export function mergerHeader(customTopHeader, worksheet: any) {
  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  let start = 1;
  customTopHeader.forEach((topHeader, i) => {
    const currLeft = start;
    const currRight = currLeft + topHeader.size - 1;
    worksheet.getCell(1, currLeft).value = topHeader.title;
    worksheet.getCell(1, currLeft).style = greyHeaderStyle;
    worksheet.mergeCells(1, currLeft, 1, currRight);
    start = currRight + 1;
  });
}

export async function fundApplicationExportTableToXlsx(
  data,
  header,
  customTopHeader,
  fundApplicationYears: number[] = []
) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  // Define styles
  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  // Add top header row and apply styles and merges

  mergerHeader(customTopHeader, worksheet);

  worksheet.addRow(header); // Add header values

  // Add data rows
  const showDivision = header.includes("Division");
  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        ...(showDivision ? [row.division] : []),
        // row.totalNumberApproved,
        // row.totalAreaApproved,
        // row.totalNumberSelected,
        // row.totalAreaSelected,
        row.totalNumberDemandNoteRaised,
        // row.totalAreaDemandNoteRaised,
        row.totalAmountDemandNoteRaised,
        // row.totalNumberPaymentReceived,
        // row.totalAreaPaymentReceived,
        row.totalAmountPaymentReceived,
        row.totalEcoRestorationCost,
        // row.totalNumberFundApplicationPending,
        // row.totalAreaFundApplicationPending,
        // row.totalNumberFundApplicationReceived,
        // row.totalAreaFundApplicationReceived,
        // row.totalAmountFundApplicationReceived,
        row.totalNumberPaymentReleased,
        row.totalAmountPaymentReleased,
        row.totalFinancialProgress,
        ...fundApplicationYears.flatMap((year) => {
          const release = row.faPaymentReleased?.[`FA${year}`];
          return [
            release?.totalNumber ?? 0,
            release?.totalAmount ?? "0.00",
            release?.totalUcUploaded ?? 0,
            release?.totalUcPending ?? 0,
          ];
        }),
        row.totalAmountFundApplicationPending,
        // row.totalBalanceWithAdmin, // never set by the API or the row mapping — always undefined
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DashboardTable.xlsx"
  );
}

export async function exportNewSelectedTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1);
    topHeaderColStart += 2;
  });

  const headerRowIndex = 2;
  worksheet.addRow(header);
  header.forEach((_item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberRegisteredNewOm,
        row.totalAreaRegisteredNewOm,
        row.totalNumberApprovedNewOm,
        row.totalAreaApprovedNewOm,
        row.totalNumberAllIncludingDeselect,
        row.totalAreaAllIncludingDeselect,
        row.totalNumberNewSelected,
        row.totalAreaNewSelected,
        row.totalNumberProvisionalSelected,
        row.totalAreaProvisionalSelected,
        row.totalNumberSiteVisited,
        row.totalAreaSiteVisited,
        row.totalNumberAcknowledgeByApprover,
        row.totalAreaAcknowledgeByApprover,
        row.totalNumberDeselect,
        row.totalAreaDeselect,
        row.totalNumberAvailableLand,
        row.totalAreaAvailableLand,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "NewSelectedDashboardTable.xlsx"
  );
}

export async function exportDprTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1);
    topHeaderColStart += 2;
  });

  const headerRowIndex = 2;
  worksheet.addRow(header);
  header.forEach((_item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberAllDpr,
        row.totalAreaAllDpr,
        row.totalNumberDprUnderDno,
        row.totalAreaDprUnderDno,
        row.totalNumberQueryFromDno,
        row.totalAreaQueryFromDno,
        row.totalNumberDprUnderSno,
        row.totalAreaDprUnderSno,
        row.totalNumberQueryFromSno,
        row.totalAreaQueryFromSno,
        row.totalNumberDprUnderAdmin,
        row.totalAreaDprUnderAdmin,
        row.totalNumberQueryFromAdmin,
        row.totalAreaQueryFromAdmin,
        row.totalNumberDprApproved,
        row.totalAreaDprApproved,
        row.totalNumberDprRejected,
        row.totalAreaDprRejected,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "DprDashboardTable.xlsx"
  );
}

export async function exportMouTableToXlsx(data, header, topHeader) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("DashboardTable");

  const centerStyle = {
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  const greyHeaderStyle = {
    fill: {
      type: "pattern" as const,
      pattern: "solid" as const,
      fgColor: { argb: "FFDDDDDD" as const },
    },
    font: { bold: true },
    alignment: { horizontal: "center" as const, vertical: "middle" as const },
    border: {
      top: { style: "thin" as const },
      left: { style: "thin" as const },
      bottom: { style: "thin" as const },
      right: { style: "thin" as const },
    },
  };

  let topHeaderColStart = 1;
  topHeader.forEach((headerTitle) => {
    worksheet.getCell(1, topHeaderColStart).value = headerTitle;
    worksheet.getCell(1, topHeaderColStart).style = greyHeaderStyle;
    worksheet.mergeCells(1, topHeaderColStart, 1, topHeaderColStart + 1);
    topHeaderColStart += 2;
  });

  const headerRowIndex = 2;
  worksheet.addRow(header);
  header.forEach((_item, index) => {
    worksheet.getCell(headerRowIndex, index + 1).style = greyHeaderStyle;
  });

  data.forEach((row) => {
    worksheet
      .addRow([
        row.sno,
        row.state,
        row.totalNumberMouPending,
        row.totalAreaMouPending,
        row.totalNumberMouUnderDno,
        row.totalAreaMouUnderDno,
        row.totalNumberQueryFromDno,
        row.totalAreaQueryFromDno,
        row.totalNumberMouUnderSno,
        row.totalAreaMouUnderSno,
        row.totalNumberQueryFromSno,
        row.totalAreaQueryFromSno,
        row.totalNumberMouUnderAdmin,
        row.totalAreaMouUnderAdmin,
        row.totalNumberQueryFromAdmin,
        row.totalAreaQueryFromAdmin,
        row.totalNumberMouApproved,
        row.totalAreaMouApproved,
        row.totalNumberMouRejected,
        row.totalAreaMouRejected,
      ])
      .eachCell({ includeEmpty: true }, (cell) => {
        cell.style = centerStyle;
      });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/octet-stream" }),
    "MouDashboardTable.xlsx"
  );
}

/**
 * Computes the batch cutoff date for the weekly visibility filter.
 * Mon 12PM – Thu 12PM: cutoff = this Monday 12:00 PM
 * Thu 12PM – Mon 12PM: cutoff = this Thursday 12:00 PM
 */
export const getBatchCutoffDate = (): Date => {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
  const hour = now.getHours();

  const inMonThuWindow =
    (dayOfWeek === 1 && hour >= 12) ||
    dayOfWeek === 2 ||
    dayOfWeek === 3 ||
    (dayOfWeek === 4 && hour < 12);

  const cutoff = new Date(now);
  if (inMonThuWindow) {
    const daysFromMonday = (dayOfWeek + 6) % 7;
    cutoff.setDate(now.getDate() - daysFromMonday);
  } else {
    const daysFromThursday = (dayOfWeek + 3) % 7;
    cutoff.setDate(now.getDate() - daysFromThursday);
  }
  cutoff.setHours(12, 0, 0, 0);
  return cutoff;
};

export async function downloadS3File(
  signedUrl: string | undefined | null,
  filename: string
): Promise<void> {
  if (!signedUrl) return;
  const key = signedUrl.split("?")[0].split("/").pop();
  const response = await adminInstance.get(`v1/upload/file/${key}/download`, {
    responseType: "blob",
    params: { filename },
  });
  saveAs(new Blob([response.data]), filename);
}
